<template>
	<Tag :color="tagColor" :class="classes">
		{{ displayName }}
	</Tag>
</template>

<script>
import { computed, toRef } from 'vue';
import { Tag } from 'ant-design-vue';

import Consts from '@/api/Consts';
import MapHelpers from '@/components/map/utils/MapHelpers';

export default {
	components: {
		Tag,
	},
	props: {
		code: {
			type: String,
			required: true,
		},
		forceGrey: {
			type: Boolean,
			required: false,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const codeRef = toRef(props, 'code');
		const forceGreyRef = toRef(props, 'forceGrey');
		const smallRef = toRef(props, 'small');
		const display = computed(() => MapHelpers.getGnssDataDisplay(codeRef.value));
		const displayName = computed(() => smallRef.value ? display.value.code : display.value.name);
		const classes = computed(() => ['gnss-tag', smallRef.value ? 'gnss-tag-small' : '']);
		const tagColor = computed(() => {
			if (forceGreyRef.value) {
				return Consts.COLORS.gray;
			}
			return '#' + display.value.color;
		});
		return {
			displayName,
			tagColor,
			classes,
		};
	},
};
</script>

<style scoped>
.gnss-tag {
	margin-inline-end: 4px;
}

.gnss-tag:last-child {
	margin-inline-end: 0;
}

.gnss-tag-small {
	padding-inline: 2px;
	margin-inline-end: 1px;
}
</style>
